import "./Contact.css"
import {useState, useRef, useEffect} from "react";
import Loading from "../UI/Loading/Loading";
import {UilLocationPoint} from "@iconscout/react-unicons";

const Contact = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [contact, setContact] = useState({
        name: null,
        number: null,
        email: null,
        massage: null,
        attachment: null,
        category: null
    })

    let attachmentRef = useRef(null)

    const changeInputHandler = (e) => {
        let {name, value} = e.target
        setContact({
            ...contact,
            [name]: value,
        })
    }
    const handleFileSelect = (selectedFile) => {
        setContact({
            ...contact,
            attachment: selectedFile
        })
    };

    const handleButtonClick = () => {
        attachmentRef.current.click();
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        handleFileSelect(selectedFile);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const loadingTimeout = setTimeout(() => {
            setIsLoading(false);
        }, 2000);

        return () => {
            clearTimeout(loadingTimeout);
        };
    }, [])


    return (
        <>
            {isLoading && <Loading/>}
            <div>
                <div className="contact-first">
                    <h1 className={"upToBottomAnimation"}>Contact us to learn more about Arnikup</h1>
                </div>
                <div className={"contact-detail-container"}>
                    <div className="contact-information">
                        <div>
                            <h1>Additional Information</h1>
                            <p className={"info-p"}>Please contact us for additional information about Arnikup and the
                                solutions we can deliver for
                                you.</p>
                        </div>
                        <div className={"contact-info-detail"}>
                            <div>
                                <p>Support Services</p>
                                <p>Service@Arnikup.com</p>
                            </div>
                            <div>
                                <p>Investors</p>
                                <p>Investors@Arnikup.com</p>
                            </div>
                            <div>
                                <p>General Inquiries</p>
                                <p>Info@Arnikup.com</p>
                            </div>
                            <div>
                                <p>Fax</p>
                                <p>+98 21 220 23149</p>
                            </div>
                            <div>
                                <p>Phone Number</p>
                                <p>+98 21 220 23147</p>
                            </div>
                        </div>
                    </div>
                    <div className={"contact-location"}>
                        <h1>Location</h1>
                        <div>
                            <div className={"location-detail"}>
                                <h3>Tehran</h3>
                                <div>No. 13, Tooraj st. Vali Asr St. Parkway, Tehran,iran</div>
                                <p>
                                    <UilLocationPoint/>
                                    <a target="_blank"
                                       rel="noreferrer"
                                       href="https://www.google.ca/maps/place/Parkway+beauty+center/@35.788749,51.4175854,19z/data=!4m5!3m4!1s0x3f8e066c3c2e8947:0x64f2dd0894d0a513!8m2!3d35.7890221!4d51.416711">View
                                        on map </a>
                                </p>
                            </div>
                            <div className={"location-detail"}>
                                <h3>London</h3>
                                <div>Kemp House 152-160 City Road, London, London, United Kingdom, EC1V 2NX</div>
                                <p>
                                    <UilLocationPoint/>
                                    <a target="_blank"
                                       rel="noreferrer"
                                       href="https://www.google.co.uk/maps/dir//EC1V+2NX,+London,+UK/@51.5273038,-0.0910827,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x48761ca66eeaa42d:0xfeaa9eff15ff6f43!2m2!1d-0.088894!2d51.5273038?hl=en">View
                                        on map</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="contact-us">
                    <h1>
                        Would you like to Contact us?
                    </h1>
                    <form action="">
                        <div className={"contact-us-div"}>
                            <div>
                                <input type="text" name={"name"} placeholder={"Your Name"} onChange={changeInputHandler}
                                       value={contact.name}/>
                                <br/>
                                <input type="number" name={"number"} placeholder={"Phone Number"}
                                       onChange={changeInputHandler}
                                       value={contact.number}/>
                                <br/>
                                <div className={"contact-attachment"}>
                                    <button onClick={handleButtonClick}>
                                        Select File
                                    </button>
                                    <p>
                                        {
                                            contact.attachment && contact.attachment.name ? contact.attachment.name : (
                                                " No File Chosen"
                                            )
                                        }
                                    </p>
                                </div>
                                <input onChange={handleFileChange} ref={attachmentRef} type="file"
                                       style={{display: "none"}}/>
                            </div>
                            <div>
                                <input type="email" name={"email"} placeholder={"Email Address"}
                                       onChange={changeInputHandler}
                                       value={contact.email}/>
                                <br/>
                                <textarea placeholder={"Massage"} name={"massage"} onChange={changeInputHandler}
                                          value={contact.massage}/>
                            </div>
                        </div>
                        <div className={"contact-category"}>
                            <p>Your category</p>
                            <div>
                                <p>
                                    <label>
                                        Investor
                                    </label>
                                    <input type="radio" value={"Investor"} onChange={changeInputHandler}
                                           name={"category"}/>
                                </p>
                                <p>
                                    <label>
                                        Startup
                                    </label>
                                    <input type="radio" value={"Startup"} onChange={changeInputHandler}
                                           name={"category"}/>
                                </p>
                            </div>
                        </div>
                        <div className={"form-btn"}>
                            <button>
                                Send
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
export default Contact;